// extracted by mini-css-extract-plugin
export var bottomCenter = "Dropdown-module--bottomCenter--e595d";
export var bottomLeft = "Dropdown-module--bottomLeft--86d73";
export var menu = "Dropdown-module--menu--4a808";
export var topLeft = "Dropdown-module--topLeft--3a921";